export default "__VITE_ASSET__BPjNMIFY__"